<template>
  <v-layout :row="!vertical" :column="vertical" wrap justify-space-between>
    <v-flex>
      <DatePicker :date="startDate" :minStart="minStart" :maxEnd="maximumStartDate"
                  @updated="updatedStart" :attach="attach"
                  :title="$t('date_from')" :disabled="startDisabled" :width="width"></DatePicker>
    </v-flex>
    <v-flex>
      <DatePicker :date="dateRange.endDate" @updated="updatedEnd" :attach="attach"
                  :minStart="minEnd || dateRange.startDate" :maxEnd="maximumEndDate"
                  :title="$t('date_to')" :disabled="indefiniteEnd || endDisabled" :width="width"></DatePicker>
      <v-flex v-if="indefinite">
        <v-checkbox color="primary" :label="$t('indefinite')" v-model="indefiniteEnd" :hide-details="hideDetails"></v-checkbox>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
  import DatePicker from './DatePicker'
  import moment from 'moment-es6'

  export default {
    name: 'date-range-picker',
    props: {
      dateRange: {},
      indefinite: {},
      now: {
        default: moment().format('YYYY-MM-DD')
      },
      minStart: {
        default: null
      },
      maxStart: {
        default: null
      },
      minEnd: {
        default: null
      },
      maxEnd: {
        default: null
      },
      updateStart: {
        type: String,
        default: null
      },
      updateEnd: {
        type: String,
        default: null
      },
      id: {
        default: null
      },
      startDisabled: {
        type: Boolean,
        default: false
      },
      endDisabled: {
        type: Boolean,
        default: false
      },
      endUnlimited: { // start and end can be in future
        type: Boolean,
        default: false
      },
      width: {
        type: Number,
        default: undefined
      },
      vertical: {
        type: Boolean,
        default: false
      },
      attach: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        previousEndDate: moment().format('YYYY-MM-DD')
      }
    },
    computed: {
      startDate () {
        return this.dateRange.startDate
      },
      indefiniteEnd: {
        get () {
          return !moment(this.dateRange.endDate, 'YYYY-MM-DD').isValid()
        },
        set (value) {
          this.indefiniteEndChanged(value)
        }
      },
      maximumStartDate () {
        return this.getMaximum(this.maxStart)
      },
      maximumEndDate () {
        return this.getMaximum(this.maxEnd)
      }
    },
    methods: {
      getMaximum (max) {
        if (max) {
          return max
        }
        if (this.endUnlimited) {
          return null
        }
        return this.now
      },
      updatedStart (newStart) {
        if (this.updateStart) {
          this.$store.commit(this.updateStart, {start: newStart, id: this.id})
        } else {
          this.dateRange.startDate = newStart
        }

        this.emitResult()
      },
      updatedEnd (newEnd) {
        if (this.updateEnd) {
          this.$store.commit(this.updateEnd, {end: newEnd, id: this.id})
        } else {
          this.dateRange.endDate = newEnd
        }

        this.emitResult()
      },
      emitResult () {
        this.$emit('updated',
          {startDate: this.dateRange.startDate, endDate: this.dateRange.endDate})
      },
      indefiniteEndChanged (indefinite) {
        if (indefinite) {
          this.previousEndDate = this.dateRange.endDate
          this.updatedEnd(null)
        } else {
          this.updatedEnd(moment(this.previousEndDate, 'YYYY-MM-DD').isValid() ? this.previousEndDate : moment().format('YYYY-MM-DD'))
        }
      }
    },
    components: {
      DatePicker
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/date/DateRangePicker.vue